import { render, staticRenderFns } from "./create-account-dialog.vue?vue&type=template&id=4f47553d&scoped=true&"
import script from "./create-account-dialog.vue?vue&type=script&lang=js&"
export * from "./create-account-dialog.vue?vue&type=script&lang=js&"
import style0 from "./create-account-dialog.vue?vue&type=style&index=0&id=4f47553d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f47553d",
  null
  
)

export default component.exports